export const ApplicationStatus = [
  { key: "not-applied", value: "Not Applied" },
  { key: "applied", value: "Applied" },
  { key: "selected", value: "Selected" },
  { key: "rejected", value: "Rejected" },
  { key: "pending", value: "Pending" },
];
